import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import {
  AutomationName,
  AutomationType,
  Forms,
  RequestOptions,
  SendConditions,
  SendFrequency,
  SendHours,
  SendTiming,
} from './FormFields';
import { LinkedAutomations } from './FormFields/LinkedAutomations';
import { useGetFieldVisibility } from 'pages/Automations/hooks/useGetFieldVisibility';
import { LapsedConditions } from './FormFields/LapsedConditions';
import { useCurrentAutomationId } from 'pages/Automations/hooks/useCurrentAutomationId';

export const AutomationsSettings = (): JSX.Element => {
  const currentAutomationId = useCurrentAutomationId();
  const fieldIsVisible = useGetFieldVisibility();

  return (
    <Flex flexDirection="column" className="Automations__Settings" width={600} py={10} px={0}>
      <AutomationName />
      <AutomationType />
      {fieldIsVisible.sendConditions && <SendConditions key={`send-conditions-${currentAutomationId}`} />}
      {fieldIsVisible.lapsedConditions && <LapsedConditions />}
      {fieldIsVisible.sendTiming && <SendTiming />}
      {fieldIsVisible.sendHours && <SendHours />}
      {fieldIsVisible.sendFrequency && <SendFrequency />}
      {fieldIsVisible.requestOptions && <RequestOptions />}
      {fieldIsVisible.forms && <Forms />}
      {fieldIsVisible.linkedAutomations && <LinkedAutomations />}
    </Flex>
  );
};
